import { render, staticRenderFns } from "./LayoutAnalyticsTab.vue?vue&type=template&id=23247d38"
import script from "./LayoutAnalyticsTab.vue?vue&type=script&lang=ts"
export * from "./LayoutAnalyticsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports